import { render } from "./ChooseDataResearch.vue?vue&type=template&id=601f9d0a&scoped=true"
import script from "./ChooseDataResearch.vue?vue&type=script&lang=js"
export * from "./ChooseDataResearch.vue?vue&type=script&lang=js"

import "./ChooseDataResearch.vue?vue&type=style&index=0&id=601f9d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601f9d0a"]])

export default __exports__